import React from 'react'
import {styles} from '../../styles/TherapySection.style'
import {Color} from '../../../../style/custom/colors'
import {i18n} from '../../../../i18n'

/**
 * Component representing a patient diagnosis entry.
 */
const DiagnosisEntryHead: React.FC = () => {
    return (
        <div style={{display: 'contents'}}>
            <div style={styles.entryHead}>
                {/* Empty - For Edit */}
            </div>
            <div style={styles.entryHead}>
                <span>{i18n.t('diagnosis.headCode')}</span>
            </div>
            <div style={styles.entryHead}>
                <span>{i18n.t('diagnosis.headDescription')}</span>
            </div>
            <div style={styles.entryHead}>
                <span>{i18n.t('diagnosis.headCause')}</span>
            </div>
            <div style={styles.entryHead}>
                {/* Empty - For Delete */}
            </div>
        </div>
    )
}

export default DiagnosisEntryHead
